import { Menu, Tooltip } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { InputContextBadge } from 'app/modules/wallforming/components/content-container/scene-status-bar/InputContextBadge';
import { inputContexts } from 'app/modules/wallforming/components/input-binding/registry/inputActionsRegistry';
import { InputContext } from 'app/modules/wallforming/components/input-binding/types/inputContext';
import { resolveInputContext } from 'app/modules/wallforming/components/input-binding/utils/inputContextUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const selectableContexts = Object.values(InputContext);

export const InputContextSelection = () => {
    const { t } = useTranslation();
    const { selectedContext, selectInputContext } = usePlacementStore(
        useShallow((state) => ({
            selectedContext: resolveInputContext(state),
            selectInputContext: state.selectInputContext
        }))
    );

    return (
        <div
            className="wallforming-context-badges max-w-full"
            data-testid="input-context-row"
            data-input-ui
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.stopPropagation();
                }
            }}
        >
            <div className="hidden items-center gap-1 px-1 py-1 @min-[40rem]/scene-context:flex">
                {selectableContexts.map((context) => (
                    <InputContextBadge
                        key={context}
                        context={context}
                        selected={context === selectedContext}
                        onSelect={() => selectInputContext(context)}
                    />
                ))}
            </div>
            <div className="px-1 py-1 @min-[40rem]/scene-context:hidden">
                <Menu position="bottom-start" withinPortal>
                    <Menu.Target>
                        <button
                            aria-label={t('labelInputContextCurrent')}
                            className="flex h-9 w-14 cursor-pointer items-center justify-center gap-1 rounded bg-background-highlight text-text-accent"
                            data-testid="input-context-select"
                            type="button"
                        >
                            <Icon icon={inputContexts[selectedContext].icon} size="sm" />
                            <Icon icon="expand_more" size="sm" />
                        </button>
                    </Menu.Target>
                    <Menu.Dropdown data-input-ui>
                        <div className="grid grid-cols-5 gap-1">
                            {selectableContexts.map((context) => (
                                <Tooltip key={context} label={t(inputContexts[context].labelKey)}>
                                    <Menu.Item
                                        aria-label={t(inputContexts[context].labelKey)}
                                        aria-pressed={context === selectedContext}
                                        className="h-10 w-10! p-0!"
                                        onClick={() => selectInputContext(context)}
                                    >
                                        <span
                                            className={`flex h-10 w-10 items-center justify-center rounded ${
                                                context === selectedContext ? 'bg-background-highlight' : ''
                                            }`}
                                        >
                                            <Icon icon={inputContexts[context].icon} size="sm" />
                                        </span>
                                    </Menu.Item>
                                </Tooltip>
                            ))}
                        </div>
                    </Menu.Dropdown>
                </Menu>
            </div>
        </div>
    );
};
